import { render } from "./JournalTabRoute.vue?vue&type=template&id=1df66dea&scoped=true"
import script from "./JournalTabRoute.vue?vue&type=script&lang=js"
export * from "./JournalTabRoute.vue?vue&type=script&lang=js"

import "./JournalTabRoute.vue?vue&type=style&index=0&id=1df66dea&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df66dea"]])

export default __exports__